<template>
  <button v-on = "$listeners">
    <slot>Test</slot>
  </button>
</template>

<script>
export default {
  name: 'BaseButton'
}
</script>

<style lang="scss">
@import "../utilities/variables";

/*.translate-button {
  font-family: 'Unistra A';
  font-size: 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  vertical-align: middle;

  cursor: pointer;
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;

  padding: 5px 10px;

  //background-color: $button-color;

  border: $button-color-blue solid 1px;
  //border-color: transparent;
  line-height: 1.8461538462;
  border-radius: 0px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  &-selected {
    background-color: darken($button-color, 5%);
    font-weight: 550;
  }
  &:hover {
    background-color: darken($button-color, 10%);
    font-weight: 700;
  }
}*/
</style>
